(function () {
  function initMegaMenu() {
    const l3Links = document.querySelectorAll('.shop-mega-menu__l3-link');
    const productContainer = document.getElementById('shop-mega-products');
    const groupLabels = document.querySelectorAll('.shop-mega-menu__group-label');

    if (!productContainer) return;

    // ── 手风琴：点击二级标签 ──
    groupLabels.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const group = btn.closest('.shop-mega-menu__group');
        const list = group.querySelector('.shop-mega-menu__l3-list');
        const isOpen = group.classList.contains('is-open');

        document.querySelectorAll('.shop-mega-menu__group').forEach(g => {
          g.classList.remove('is-open');
          g.querySelector('.shop-mega-menu__l3-list')?.classList.remove('is-open');
          g.querySelector('.shop-mega-menu__group-label')?.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          group.classList.add('is-open');
          list?.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');

          const firstL3 = group.querySelector('.shop-mega-menu__l3-link');
          if (firstL3) {
            l3Links.forEach(l => l.classList.remove('is-active'));
            firstL3.classList.add('is-active');
            loadProducts(
              firstL3.dataset.collectionHandle,
              firstL3.textContent.trim(),
              firstL3.getAttribute('href'),
              (firstL3.dataset.taglines || '').split('|')
            );
          }
          // 关闭所有已展开的
tier2Container.querySelectorAll('.mega-l3-open').forEach(openLi => {
  openLi.classList.remove('mega-l3-open');
  openLi.querySelector('.shop-mega-menu-mobile__products').style.display = 'none';
  // 重置父容器高度，让主题重新计算
  const parentContainer = openLi.closest('.navigation__tier-3-container');
  if (parentContainer) {
    parentContainer.style.height = '';
  }
});

        }
      });
    });

    // ── 三级菜单 click/hover ──
    l3Links.forEach(link => {
      const handler = (e) => {
        if (e.type === 'click') e.preventDefault();
        l3Links.forEach(l => l.classList.remove('is-active'));
        link.classList.add('is-active');
        loadProducts(
          link.dataset.collectionHandle,
          link.textContent.trim(),
          link.getAttribute('href'),
          (link.dataset.taglines || '').split('|')
        );
      };
      link.addEventListener('click', handler);
      link.addEventListener('mouseenter', handler);
    });

    // ── 加载产品（3个横排）──
    function loadProducts(handle, collectionTitle, collectionUrl, taglines) {
      if (!handle) {
        productContainer.innerHTML = `
          <div class="shop-mega-menu__products-header">
            <span class="shop-mega-menu__products-title">—</span>
          </div>
          <p style="color:#aaa;font-size:13px;">No collection linked.</p>`;
        return;
      }

      handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');

      // 骨架屏
      productContainer.innerHTML = `
        <div class="shop-mega-menu__products-header">
          <span class="shop-mega-menu__products-title">${collectionTitle}</span>
          <a href="${collectionUrl || '#'}" class="shop-mega-menu__products-viewall">View More ›</a>
        </div>
        <div class="shop-mega-menu__product-grid">
          ${[1,2,3].map(() => `
            <div class="shop-mega-menu__product-card">
              <div class="shop-mega-menu__product-img-placeholder"></div>
              <div class="shop-mega-menu__product-info">
                <div style="background:#eee;height:12px;border-radius:3px;width:90%;margin-bottom:4px"></div>
                <div style="background:#eee;height:12px;border-radius:3px;width:70%;margin-bottom:4px"></div>
                <div style="background:#eee;height:10px;border-radius:3px;width:50%"></div>
              </div>
            </div>
          `).join('')}
        </div>`;

      fetch(`/collections/${handle}/products.json?limit=3`)
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(({ products }) => {
          if (!products || !products.length) {
            productContainer.innerHTML = `
              <div class="shop-mega-menu__products-header">
                <span class="shop-mega-menu__products-title">${collectionTitle}</span>
                <a href="${collectionUrl || '#'}" class="shop-mega-menu__products-viewall">View More ›</a>
              </div>
              <p style="color:#aaa;font-size:13px;">No products in this collection.</p>`;
            return;
          }

          productContainer.innerHTML = `
            <div class="shop-mega-menu__products-header">
              <span class="shop-mega-menu__products-title">${collectionTitle}</span>
              <a href="${collectionUrl || '#'}" class="shop-mega-menu__products-viewall">View More ›</a>
            </div>
            <div class="shop-mega-menu__product-grid">
              ${products.slice(0, 3).map((p, i) => `
                <a href="/products/${p.handle}" class="shop-mega-menu__product-card">
                  <div class="shop-mega-menu__product-img-wrap">
                    ${p.images && p.images[0]
                      ? `<img src="${p.images[0].src}" alt="${p.title}" loading="lazy">`
                      : '<div style="width:100%;height:100%;background:#eee;border-radius:6px"></div>'}
                  </div>
                  <div class="shop-mega-menu__product-info">
                    <div class="shop-mega-menu__product-title">${p.title}</div>
                    <div class="shop-mega-menu__product-tagline">${taglines[i] || ''}</div>
                  </div>
                </a>
              `).join('')}
            </div>`;
        })
        .catch(err => {
          console.error('[MegaMenu]', handle, err);
          productContainer.innerHTML = `
            <div class="shop-mega-menu__products-header">
              <span class="shop-mega-menu__products-title">${collectionTitle}</span>
            </div>
            <p style="color:#aaa;font-size:13px;">Unable to load products.</p>`;
        });
    }

    // ── 初始化默认加载 ──
    const megaParent = document.querySelector('.navigation__item--shop-mega');
    let initialized = false;
    if (megaParent) {
      megaParent.addEventListener('mouseenter', () => {
        if (!initialized) {
          initialized = true;
          const firstActive = document.querySelector('.shop-mega-menu__l3-link.is-active');
          if (firstActive) {
            loadProducts(
              firstActive.dataset.collectionHandle,
              firstActive.textContent.trim(),
              firstActive.getAttribute('href'),
              (firstActive.dataset.taglines || '').split('|')
            );
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
/*新增移动端 */
// ===== Mobile Mega Menu =====
(function () {
  function initMobileMegaMenu() {
    const drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer) return;

    const shopItem = Array.from(
      drawer.querySelectorAll('.navigation__tier-1 > .navigation__item')
    ).find(item => {
      const link = item.querySelector(':scope > .navigation__link');
      return link && link.textContent.trim().toLowerCase() === 'shop';
    });

    if (!shopItem) return;
    const tier2Container = shopItem.querySelector('.navigation__tier-2-container');
    if (!tier2Container || tier2Container.dataset.megaMobileInit) return;
    tier2Container.dataset.megaMobileInit = 'true';

    const taglines = ["Editor's Choice", 'High Performance', 'Premium Quality'];

    const l3Links = tier2Container.querySelectorAll('.navigation__tier-3 .navigation__link');

    l3Links.forEach((link) => {
      const li = link.closest('li');
      if (!li) return;

      const productArea = document.createElement('div');
      productArea.className = 'shop-mega-menu-mobile__products';
      productArea.innerHTML = `
        <div class="shop-mega-menu-mobile__product-grid"></div>
        <a href="${link.getAttribute('href') || '#'}" class="shop-mega-menu-mobile__products-viewall">View All ›</a>
      `;
      li.appendChild(productArea);

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = li.classList.contains('mega-l3-open');

        if (isOpen) {
          // 再次点击折叠
          li.classList.remove('mega-l3-open');
          productArea.style.display = 'none';
          expandParentHeights(tier2Container);
        } else {
          // 展开，不关闭其他
          li.classList.add('mega-l3-open');
          productArea.style.display = 'block';
          expandParentHeights(tier2Container);

          if (!productArea.dataset.loaded) {
            productArea.dataset.loaded = 'true';
            const href = link.getAttribute('href') || '';
            let handle = '';
            if (href.includes('/collections/')) {
              handle = href.split('/collections/')[1].split('?')[0].replace(/\/$/, '');
            }
            loadMobileProducts(productArea, handle, taglines);
          }
        }
      });
    });

    // 关闭 Shop 二级菜单时重置所有产品区
    const tier1Toggle = shopItem.querySelector(':scope > .navigation__children-toggle');
    if (tier1Toggle) {
      tier1Toggle.addEventListener('click', () => {
        if (shopItem.classList.contains('navigation__item--open')) {
          tier2Container.querySelectorAll('.mega-l3-open').forEach(openLi => {
            openLi.classList.remove('mega-l3-open');
            openLi.querySelector('.shop-mega-menu-mobile__products').style.display = 'none';
          });
          tier2Container.querySelectorAll('.navigation__tier-3-container').forEach(c => {
            c.style.height = '';
          });
        }
      });
    }
  }

  function expandParentHeights(tier2Container) {
    // 撑开所有当前激活的三级容器
    const openTier2Items = tier2Container.querySelectorAll('.navigation__tier-2 > .navigation__item--open');
    openTier2Items.forEach(item => {
      const childContainer = item.querySelector('.navigation__tier-3-container');
      if (childContainer) {
        childContainer.style.height = childContainer.firstElementChild?.scrollHeight + 'px';
      }
    });

    // 确保抽屉可以滚动
    const drawer = document.querySelector('.mobile-navigation-drawer');
    if (drawer) {
      drawer.style.overflowY = 'auto';
      drawer.style.overflowX = 'hidden';
    }
  }

  function loadMobileProducts(productArea, handle, taglines) {
    if (!handle) return;
    const gridEl = productArea.querySelector('.shop-mega-menu-mobile__product-grid');

    gridEl.innerHTML = [1,2,3].map(() => `
      <div class="shop-mega-menu-mobile__product-card">
        <div class="shop-mega-menu-mobile__product-img-placeholder"></div>
        <div class="shop-mega-menu-mobile__product-info">
          <div style="background:#eee;height:12px;border-radius:3px;width:85%;margin-bottom:5px"></div>
          <div style="background:#eee;height:10px;border-radius:3px;width:55%"></div>
        </div>
      </div>
    `).join('');

    fetch(`/collections/${handle}/products.json?limit=3`)
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(({ products }) => {
        if (!products || !products.length) {
          gridEl.innerHTML = '<p style="color:#aaa;font-size:13px;padding:10px 0">No products found.</p>';
          return;
        }
        gridEl.innerHTML = products.slice(0, 3).map((p, i) => `
          <a href="/products/${p.handle}" class="shop-mega-menu-mobile__product-card">
            <div class="shop-mega-menu-mobile__product-img-wrap">
              ${p.images && p.images[0]
                ? `<img src="${p.images[0].src}" alt="${p.title}" loading="lazy">`
                : '<div style="width:100%;height:100%;background:#eee;border-radius:8px"></div>'}
            </div>
            <div class="shop-mega-menu-mobile__product-info">
              <div class="shop-mega-menu-mobile__product-title">${p.title}</div>
              <div class="shop-mega-menu-mobile__product-tagline">${taglines[i] || ''}</div>
            </div>
          </a>
        `).join('');

        expandParentHeights(document.querySelector('.mobile-navigation-drawer .navigation__tier-2-container'));
      })
      .catch(() => {
        gridEl.innerHTML = '<p style="color:#aaa;font-size:13px;padding:10px 0">Unable to load products.</p>';
      });
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.navigation__tier-1 > .navigation__item > .navigation__children-toggle');
    if (toggle) setTimeout(initMobileMegaMenu, 300);
  });

  setTimeout(initMobileMegaMenu, 1000);
})();

